import { Skeleton, Stack } from '@mui/material';
import { MaterialIcon } from '@common/ui/MaterialIcon';

export default function AccessSessionHeaderSkeleton({ withArrow = true }: { withArrow?: boolean }) {
  return (
    <Stack direction="row" alignItems="center" spacing={1} sx={{ flex: 1 }}>
      {withArrow && <MaterialIcon symbol="arrow_right_alt" color="success" />}
      <Skeleton variant="circular" width={20} height={20} />
      <Stack>
        <Skeleton variant="text" width={150} height={20} />
        <Skeleton variant="text" width={180} height={20} />
      </Stack>
    </Stack>
  );
}
